import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "@/components/common/Input";
import { Button } from "@/components/common/Button";
import { Switch } from "@/components/common/Switch";
import { authService } from "@/api/services/auth.service";
import { storage } from "@/utils/storage";
import { useAuth } from "@/context/AuthContext";
import { getHomeRoute } from "@/utils/navigation";
import { loginSchema } from "./schema";
import styles from "./Login.module.css";
export const Login = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { isAuthenticated, user } = useAuth();
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, formState: { errors }, } = useForm({
        resolver: zodResolver(loginSchema),
        defaultValues: {
            email: searchParams.get("email") || storage.getEmail() || "",
            rememberMe: storage.getRememberMe(),
        },
    });
    // Redirect if already authenticated
    useEffect(() => {
        if (isAuthenticated && user) {
            navigate(getHomeRoute(user.role), { replace: true });
        }
    }, [isAuthenticated, user, navigate]);
    const onSubmit = async (data) => {
        setLoading(true);
        setErrorMessage("");
        try {
            await authService.login({
                email: data.email,
                rememberMe: data.rememberMe,
            });
            storage.setEmail(data.email);
            if (data.rememberMe) {
                storage.setRememberMe(true);
            }
            navigate("/otp");
        }
        catch (error) {
            const message = error.response?.data?.message ||
                "Something went wrong. Please contact the Administrator.";
            setErrorMessage(message);
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx("div", { className: styles.container, style: { backgroundImage: `url(/images/bg-login.png)` }, children: _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.brandPanel, children: _jsx("img", { src: "/images/logo-login.png", alt: "Defit Group logo" }) }), _jsxs("div", { children: [_jsx("div", { className: styles.formWrapperOuter, children: _jsxs("div", { className: styles.formWrapper, children: [_jsx("div", { children: _jsx("h2", { children: "Welcome to The Defit Group Portal" }) }), errorMessage ? (_jsx("small", { className: styles.errorMessage, children: errorMessage })) : (_jsx("small", { children: "Enter your email to receive a one-time passcode" })), _jsxs("form", { className: styles.loginForm, onSubmit: handleSubmit(onSubmit), children: [_jsxs("div", { children: [_jsx(Controller, { name: "email", control: control, render: ({ field }) => (_jsx(Input, { ...field, type: "email", placeholder: "Email", error: errors.email?.message, icon: _jsx("span", { className: "material-symbols-outlined", children: "mail" }) })) }), _jsx("div", { className: styles.switchRow, children: _jsx(Controller, { name: "rememberMe", control: control, render: ({ field: { value, ...field } }) => (_jsx(Switch, { ...field, checked: value, label: "Remember me for 30 days" })) }) })] }), _jsx(Button, { type: "submit", loading: loading, children: "Send Code" })] })] }) }), _jsx("p", { className: styles.termsText, children: "Terms & Conditions | Privacy Policy" })] })] }) }));
};
